import styles from './index.module.scss';

var getPlacement = function getPlacement(placement) {
  switch (placement) {
    case 'left':
      return {
        rootClassName: styles.containerLeft,
        iconClassName: styles.iconContainerLeft,
        labelWidth: 'full',
        labelLeftMargin: 0,
        inputClassName: styles.inputLeft
      };

    default:
      return {
        rootClassName: styles.containerRight,
        iconClassName: styles.iconContainerRight,
        labelWidth: 'auto',
        labelLeftMargin: 5,
        inputClassName: styles.inputRight
      };
  }
};

export default getPlacement;